import * as React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import { TableHead } from '@mui/material';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import styled from 'styled-components';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import ReactTooltip from "react-tooltip";
import { useSelector } from 'react-redux'
import useAuth from '../../../features/hooks/useAuth'
import { useGetAssetsFinalQuery } from '../../../features/addassets/addassetfinalApiSlice'
import { useGetAssetMastersQuery } from '../../../features/assetmasterApiSlice/assetmasterApiSlice'
import { useGetStoreOfficesQuery } from '../../../features/storeoffices/storeofficesApiSlice'
import { useState } from 'react';
import { TableContStyle, TableHeadStyle } from '../../../Styles/TableStyles'
import { HeadingWrap, Span } from '../../../Styles/CommonStyles'
import Select from 'react-select';


const SearchContainer = styled.div`
display: flex;
align-items: flex-end;
align-content: flex-end;
margin: 20px 5px;
`
const SpecSearchCont = styled.div`
display: flex;
`
const SelectContainer = styled.div`
margin: 15px;
display: flex;
align-items: center;
`
const Option = styled.option`
font-size: 15px;
font-weight: 100;
`
const Styledlabel = styled.label`
width: 25%;
margin-right: 10px;
font-size: 30px;
font-weight: 300;
`
const SpecificationContainer = styled.div`
overflow-y: auto;
height: 30vh;
background-color: #adbcbe;
border-radius: 10px;
width: 100%;
margin-top: 25px;
display: flex;
flex-direction: column;
`
const Specwrapper = styled.div`
width: 100%;
display: flex;
flex-wrap: wrap;
`
const SpecItemwrapper = styled.div`
width: 100%;
padding: 10px;
display: flex;
`
const SpecLabel = styled.label`
width:150px;
margin-right: 10px;
font-size: 20px;
font-weight: 150;
`
const SelectTagsContainer = styled.div`
margin-top: 10px;
margin-bottom: 10x;
`

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};


export default function CustomPaginationActionsTable({ selectedOptions, setSelectedOptions}) {

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    const [selected, setSelected] = React.useState('Asset');
    const [catSelectedValue, setCatSelectedValue] = useState("");
    const [AssetSelect, setAssetSelect] = useState("");
    const [query, setQuery] = React.useState('')
    const [specval, setSpecval] = useState({});

    // logged in user info
    const { id, email, designation, designationSuffix, numSuffix, office, roles } = useAuth()
    let user_current_office = (useSelector((state) => state.office.off))
    let user_current_role_array = roles[user_current_office]

    // store offices 
    const {
        data: allstoreoffices
    } = useGetStoreOfficesQuery('allstorelists', {
        refetchOnFocus: true,
        refetchOnMountOrArgChange: true
    });

    let tempstoredata = allstoreoffices ? Object.values(allstoreoffices?.entities) : []

    // all assets call 
    const {
        data: allassets,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetAssetsFinalQuery('allassetlist', {
        refetchOnFocus: true,
        refetchOnMountOrArgChange: true
    });

    let allassettempdata = allassets ? Object.values(allassets?.entities) : []

    // assetmaster data called
    const {
        data: assetmasters,
        assetmastersisLoading,
    } = useGetAssetMastersQuery('assetmasterlist', {
        refetchOnFocus: true,
        refetchOnMountOrArgChange: true
    });

    let assetmasterstempdata = assetmasters ? Object.values(assetmasters?.entities) : []
    let CatIndex = assetmasterstempdata?.findIndex(elm => elm.Category === catSelectedValue);
    let nameindex = CatIndex !== -1 && assetmasterstempdata[CatIndex].Asset.findIndex(elm => elm.Name === AssetSelect)
    let Specification = CatIndex !== -1 && nameindex !== -1 && assetmasterstempdata[CatIndex].Asset[nameindex].Specifications
    const handleSpec = (event, newValue, name) => { setSpecval({ ...specval, [name]: newValue }) }

    // find applicable categories based on store of user logged in (assetmanager level-1 or 2)
    let selectedStoreDoc = tempstoredata.filter(elm => elm.storeoffice === user_current_office)
    let applCatarray = selectedStoreDoc[0]?.ApplAssetCateg

    // assets in the present store
    let rows = allassettempdata?.filter(elm => (elm.cur_loc === 'store') && (elm.cur_loc_name === user_current_office))

    //selected specification filters
    let selectedKeySpecArray = Object.keys(specval)
    let lengthofselectedspeckeys = selectedKeySpecArray?.length

    const filterSpecFn = (row, keySpecArray) => {
        if (lengthofselectedspeckeys > 0) {
            for (let i = 0; i <= lengthofselectedspeckeys; i++) {
                row = row.filter(elm => (elm.specification[keySpecArray[i]] === specval[keySpecArray[i]]))
            }
            return row
        } else if (lengthofselectedspeckeys === 0) {
            return row
        }
    }

    // filtered rows by specifications 
    let specfiltrows = filterSpecFn(rows, selectedKeySpecArray)
    // after that filtered by query
    let filteredrows = specfiltrows?.filter(row => row[selected]?.toLowerCase().includes(query?.toLowerCase()))

    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    let options = specfiltrows?.filter(elmt => (elmt.cur_loc === "store") && (!elmt.in_transit)).map((element) => { return { value: element._id, label: element.oem_tag } })

    return (<>
        <HeadingWrap><Span>  All Store Assets </Span></HeadingWrap>
        <SpecSearchCont>
            <SelectContainer>
                <Autocomplete
                    id="combo-box-demo"
                    options={applCatarray?.map(elm => elm) || []}
                    sx={{ width: 350 }}
                    value={catSelectedValue}
                    onChange={(event, newValue) => {
                        setCatSelectedValue(newValue);
                    }}
                    renderInput={(params) => <TextField {...params} label="Select Category" />}
                />
                {/* <Styledlabel>Select Category:</Styledlabel>
                <CatSelect onChange={e => setCatSelectedValue(e.target.value)}>
                    <Option value='' selected disabled>Select value</Option>
                    {applCatarray?.map((elm, index) => (<Option key={index} value={elm}>{elm}</Option>))}
                </CatSelect> */}
            </SelectContainer>
            {CatIndex !== -1 && <SelectContainer>
                <Autocomplete
                    id="combo-box-demo"
                    options={CatIndex !== -1 && assetmasterstempdata[CatIndex].Asset.map(elm => elm.Name) || []}
                    sx={{ width: 350 }}
                    value={AssetSelect}
                    onChange={(event, newValue) => {
                        setAssetSelect(newValue);
                    }}
                    renderInput={(params) => <TextField {...params} label="Select Asset Name" />}
                />

                {/* <Styledlabel>Select Asset Name:</Styledlabel>
                <SubcatSelect value={AssetSelect} onChange={e => setAssetSelect(e.target.value)}>
                    <Option value='' selected disabled>Select value</Option>
                    {CatIndex !== -1 && assetmasterstempdata[CatIndex].Asset.map((elm) => (<Option key={elm.Name} value={elm.Name}>{elm.Name}</Option>))}
                </SubcatSelect> */}
            </SelectContainer>}
            {AssetSelect && <SpecificationContainer>
                <Specwrapper>
                    {Specification !== false && Specification?.map((elm) => (<SpecItemwrapper>
                        <Autocomplete
                            id="combo-box-demo"
                            options={elm[Object.keys(elm)[0]] || []}
                            sx={{ width: 350 }}
                            value={specval[Object.keys(elm)]}
                            onChange={(event, newValue) => { handleSpec(event, newValue, Object.keys(elm)) }}
                            getOptionLabel={(option) => option}
                            renderInput={(params) => <TextField {...params} label={Object.keys(elm)[0]} />}
                        />
                        {/* <SpecLabel>{Object.keys(elm)[0]}</SpecLabel>
                    <SpectSelect value={specval[Object.keys(elm)]} name={Object.keys(elm)} onChange={handleSpec} required >
                        <Option value="" selected disabled>select value</Option>
                        {Object.values(elm)?.map(elmt => { return elmt?.map(elment => <Option>{elment}</Option>) })}
                    </SpectSelect> */}
                    </SpecItemwrapper>))}
                </Specwrapper>
            </SpecificationContainer>}
        </SpecSearchCont>
        {!user_current_role_array.includes('level2approver') && <SelectTagsContainer>
            <HeadingWrap > <Span> Select Requisite Assets </Span> </HeadingWrap>
            <Select
                options={options}
                placeholder="Select all tags equal to requisite quantities"
                value={selectedOptions}
                onChange={ setSelectedOptions}
                isSearchable={true}
                isMulti
                styles={{
                    option: (provided) => ({
                        ...provided,
                        fontSize: '22px', // Set your desired font size here
                    }),
                    control: (provided) => ({
                        ...provided,
                        height: '55px', // Set your desired height here
                    }),
                    container: (provided) => ({
                        ...provided,
                        width: '400px', // Set your desired width here
                    }),
                }}
            />
        </SelectTagsContainer>}
        <TableContainer component={Paper} sx={{ backgroundColor: TableContStyle.backgroundColor , marginTop:5}}>
            <Table aria-label="custom pagination table">
                <TableHead>
                    <TableRow sx={{ backgroundColor: TableHeadStyle.backgroundColor }}>
                        <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} >SLNo</TableCell>
                        <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="right">Asset</TableCell>
                        <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="right">OEM Tag</TableCell>
                        <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="right">OEM/Brand</TableCell>
                        <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="right">Date of Purchase</TableCell>
                        <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} align="right">Date of Warranty </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {(query ? filteredrows?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) :
                        specfiltrows?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    ).map((row, index) => (
                        <TableRow key={index}>
                            <TableCell style={{ width: 60 }} component="th" scope="row">
                                {index + 1}
                                {row.in_transit && <div className="App">
                                    <div data-tip data-for={row._id}>
                                        **
                                    </div>
                                    <ReactTooltip id={row._id} place="top" effect="solid">
                                        <div>
                                            This assets is already in transit by a request.
                                        </div>
                                    </ReactTooltip>
                                </div>}
                            </TableCell>
                            <TableCell style={{ width: 160 }} align="right">
                                <div className="App">
                                    <div data-tip data-for={row._id}>
                                        {row.name}
                                    </div>
                                    <ReactTooltip id={row._id} place="top" effect="solid">
                                        <div>
                                            {Object.entries(row.specification).map(([key, val]) => <h4 key={key}>{key}: {val}</h4>)}
                                        </div>
                                    </ReactTooltip>
                                </div>
                            </TableCell>
                            <TableCell style={{ width: 160 }} align="right">
                                {row.oem_tag}
                            </TableCell>
                            <TableCell style={{ width: 160 }} align="right">
                                {row.oem}
                            </TableCell>
                            <TableCell style={{ width: 160 }} align="right">
                                {row.purchase_date}
                            </TableCell>
                            <TableCell style={{ width: 250 }} align="right">
                                {row.warrantyexp_date}
                            </TableCell>
                        </TableRow>
                    ))}
                    {emptyRows > 0 && (
                        <TableRow style={{ height: 53 * emptyRows }}>
                            <TableCell colSpan={6} />
                        </TableRow>
                    )}
                </TableBody>
                <TableFooter>
                    <TableRow>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                            colSpan={8}
                            count={rows.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            SelectProps={{
                                inputProps: {
                                    'aria-label': 'rows per page',
                                },
                                native: true,
                            }}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            ActionsComponent={TablePaginationActions}
                        />
                    </TableRow>
                </TableFooter>
            </Table>
        </TableContainer></>

    );
}
